import React from 'react'
import IconFromString from '../../IconFromString'

type DetailsParagraphProps = {
  icon: string
  title: string
  text: string
}

export default function DetailsParagraphIcon({
  icon,
  title,
  text,
}: DetailsParagraphProps) {
  return (
    <div className="flex">
      <div className="mr-2">
        <IconFromString
          iconName={icon}
          className="h-8 w-auto text-brandLightBlue md:h-10"
        />
      </div>
      <div>
        <h2 className="font-bold text-neutralBlack">{title}</h2>
        <p className="text-justify text-sm font-light text-neutralBlack">
          {text}
        </p>
      </div>
    </div>
  )
}
